// Default BOM for Twin/Twin configuration
export const TWIN_TWIN_BOM = {
  plywood: [
    { name: 'Long Boards', qty: 4, length: 77, width: 10, thickness: '11/16"', sheets: 1 },
    { name: 'Short Boards', qty: 4, length: 43.375, width: 10, thickness: '11/16"', sheets: 1 },
    { name: 'Platform Tops', qty: 4, length: 77, width: 21, thickness: '1/2"', sheets: 2 },
    { name: 'Platform Bottoms', qty: 2, length: 77, width: 21, thickness: '1/4"', sheets: 1 },
  ],
  lumber: [
    { name: 'Long Horizontals', qty: 2, length: 78.25, dimension: '1.5" x 1.5"' },
    { name: 'Short Horizontals', qty: 2, length: 39.75, dimension: '1.5" x 1.5"' },
    { name: 'Verticals', qty: 7, length: 11, dimension: '1.5" x 1.5"' },
    { name: 'X-Pieces', qty: 12, length: 17.9375, dimension: '1.5" x 1.5"' },
    { name: 'Ladder Rails', qty: 2, length: 72, dimension: '1.5" x 1.5"' },
    { name: 'Ladder Rungs', qty: 5, length: 18.5, dimension: '1.5" x 1.5"' },
  ],
  hardware: [
    { name: '2" Wood Screws', qty: 16, unitCost: 0.12 },
    { name: '2-1/2" Screws', qty: 48, unitCost: 0.12 },
    { name: '3" Wood Screws', qty: 25, unitCost: 0.12 },
    { name: '4" Wood Screws', qty: 6, unitCost: 0.24 },
    { name: '1-1/4" Trim Screws', qty: 165, unitCost: 0.10 },
    { name: '1-1/4" Pocket Screws', qty: 10, unitCost: 0.10 },
    { name: 'Narrow Crown Staples', qty: 95, unitCost: 0.01 },
    { name: 'Finish Nails', qty: 40, unitCost: 0.01 },
  ],
  cuts: {
    plywoodRips: 19,
    lumberCrossCuts: 34,
    edgeBanding: 40, // linear feet
    countersunkHoles: 250,
    pocketHoles: 10,
  },
};

// Simplified BOM calculation - in production, you'd have different BOMs per config
export function getBOMForConfig(config) {
  // For now, return Twin/Twin BOM scaled or modified based on config
  // In production, you'd have separate BOM templates for each config
  return TWIN_TWIN_BOM;
}

